import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { TELEMATIK_INFRASTRUCTURE_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/telematikInfrastructureSigningMutationParams"
import {
  De_signGeneralAttestationDocumentWithTelematikInfrastructureInput,
  useDeSignGeneralAttestationWithTelematikInfrastructureMutation as useDeSignGeneralAttestationWithTelematikInfrastructureMutationType,
} from "@/modules/patients/detail/general-attestation/de/services/__generated__/useDeSignGeneralAttestationWithTelematikInfrastructureMutation.graphql"

const mutation = graphql`
  mutation useDeSignGeneralAttestationWithTelematikInfrastructureMutation(
    $input: De_signGeneralAttestationDocumentWithTelematikInfrastructureInput!
  ) {
    de_signGeneralAttestationDocumentWithTelematikInfrastructure(input: $input) {
      de_GeneralAttestation {
        id
        createdAt
        createdBy
        signedBy
        signedAt
        updatedAt
        updatedBy
        fileId
        ...deGeneralAttestationsFragment
      }
      errors {
        __typename
        ... on Error {
          message
        }
        ... on SignDocumentMutationFailed {
          errorType
        }
      }
    }
  }
`

type Config = Omit<
  UseMutationConfig<useDeSignGeneralAttestationWithTelematikInfrastructureMutationType>,
  "variables"
> & {
  id: De_signGeneralAttestationDocumentWithTelematikInfrastructureInput["id"]
}

const useDeSignGeneralAttestationWithTelematikInfrastructureMutation = () => {
  const [commit, isFlight] =
    useMutationWithErrorDialog<useDeSignGeneralAttestationWithTelematikInfrastructureMutationType>(
      mutation,
      TELEMATIK_INFRASTRUCTURE_SIGNING_MUTATION_PARAMS,
    )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeSignGeneralAttestationWithTelematikInfrastructureMutation }
